import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {Validators, FormBuilder, FormGroup } from '@angular/forms';
import { UserData } from '../../providers/user-data'
import { ToastController, AlertController } from 'ionic-angular';
import { ChangeForgetPasswordPage } from '../change-forget-password/change-forget-password'
@IonicPage()
@Component({
  selector: 'page-forgot-password',
  templateUrl: 'forgot-password.html',
})
export class ForgotPasswordPage {
  private forgotPasswordForm : FormGroup;
  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder,private toastCtrl: ToastController,
    private alertCtrl:AlertController,private userData: UserData) {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', Validators.required]
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ForgotPasswordPage');
  }

  onSubmit(value){
    this.userData.forgetPassword(value).subscribe(
      res => {
        if(res['success']){
          this.navCtrl.push(ChangeForgetPasswordPage)
        }
      },
      err => {
        this.presentAlert('Error', 'No Account Attached With This Email Address')
      }
    )
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      showCloseButton:true
    });
    toast.present();
  }

  presentAlert(title,msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/forgot-password/forgot-password.ts